import type { FC } from 'react'

export type TRoutePageType = {
  element: FC
  path: string
  title: string
  description?: string
  seoTitle?: string
  seoDescription?: string
}

export enum ERoutePaths {
  Home = '/',

  Services = '/services',
  ServiceDetail = '/services/:slug',
  Portfolio = '/portfolio',
  PortfolioDetail = '/portfolio/:slug',
  Partners = '/partners',
  News = '/news',
  AboutUs = '/about-us',
  ContactUS = '/contact-us',

  Error = '*',
}
